var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyresources({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 35,
    viewBox: "0 0 49 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 35533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.397 25.1328L48.7195 25.1328V18.7551L16.397 18.7551V25.1328Z",
    fill: "#E30917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.6858 25.1328H45.8441V18.7551H42.6858V25.1328Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.1957 25.1328H41.514V18.7551H40.1957V25.1328Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.335 25.1328H22.4933V18.7551H19.335V25.1328Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.2129 2.5416L2.91266 33.7802L7.4942 34.9975L15.7945 3.75894L11.2129 2.5416Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.46105 27.9475L3.65002 30.9998L8.23156 32.2172L9.04258 29.1649L4.46105 27.9475Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.458 5.38162L9.64697 8.43395L14.2285 9.65129L15.0395 6.59896L10.458 5.38162Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.55589 34.8619L46.9913 34.8619V31.6738L9.55589 31.6738V34.8619Z",
    fill: "#E30917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M37.1193 34.8619H38.645V31.6738H37.1193V34.8619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M39.6535 34.8619H41.1792V31.6738H39.6535V34.8619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.2911 34.8619H14.8168V31.6738H13.2911V34.8619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M15.8231 34.8619H17.3488V31.6738H15.8231V34.8619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M35.5073 13.9967H13.0854V18.7545H35.5073V13.9967Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M48.2877 13.9967H35.5055V18.7545H48.2877V13.9967Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M35.5073 14.4911H13.0854V18.2621H35.5073V14.4911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M14.5347 15.2669C16.282 15.2397 18.0297 15.2213 19.778 15.2119L25.0198 15.1946L30.2631 15.2119C32.0103 15.2213 33.7576 15.2397 35.5048 15.2669C33.7576 15.2931 32.0103 15.312 30.2631 15.3235L25.0198 15.3392L19.7718 15.3219C18.0287 15.3125 16.283 15.2942 14.5347 15.2669Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M14.5347 16.0064C16.282 15.9802 18.0297 15.9613 19.778 15.9498L25.0198 15.9341L30.2631 15.9498C32.0103 15.9613 33.7576 15.9802 35.5048 16.0064C33.7576 16.0326 32.0103 16.0509 30.2631 16.0614L25.0198 16.0786L19.7718 16.0614C18.0287 16.0519 16.283 16.0336 14.5347 16.0064Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M14.5347 16.7479C16.282 16.7217 18.0297 16.7029 19.778 16.6914L25.0198 16.6756L30.2631 16.6914C32.0103 16.7008 33.7576 16.7196 35.5048 16.7479C33.7576 16.7752 32.0103 16.7935 30.2631 16.8029L25.0198 16.8202L19.7718 16.8029C18.0287 16.7935 16.283 16.7752 14.5347 16.7479Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M14.5347 17.4868C16.282 17.4596 18.0297 17.4407 19.778 17.4303L25.0198 17.413L30.2631 17.4303C32.0103 17.4397 33.7576 17.4586 35.5048 17.4868C33.7576 17.5141 32.0103 17.5324 30.2631 17.5418L25.0198 17.5591L19.7718 17.5418C18.0287 17.5324 16.283 17.5141 14.5347 17.4868Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M33.6197 0H15.2689V3.41593H33.6197V0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M44.0814 0H33.6199V3.41593H44.0814V0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M33.6197 0.357048H15.2689V3.06434H33.6197V0.357048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M16.4562 0.911723C17.8871 0.892868 19.3175 0.879774 20.7474 0.872441L25.0385 0.859871L29.3296 0.872441C30.7595 0.878726 32.1893 0.89182 33.6192 0.911723C32.1893 0.930578 30.7595 0.944197 29.3296 0.952577L25.0385 0.963575L20.7474 0.952577C19.3175 0.945245 17.8871 0.931626 16.4562 0.911723Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M16.4562 1.44202C17.8871 1.42316 19.3175 1.41007 20.7474 1.40274L25.0385 1.39017L29.3296 1.40274C30.7595 1.40902 32.1893 1.42212 33.6192 1.44202C32.1893 1.46087 30.7595 1.47449 29.3296 1.48287L25.0385 1.49387L20.7474 1.48287C19.3175 1.47554 17.8871 1.46192 16.4562 1.44202Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M16.4562 1.97442C17.8871 1.95557 19.3175 1.94247 20.7474 1.93514L25.0385 1.92257L29.3296 1.93514C30.7595 1.94142 32.1893 1.95452 33.6192 1.97442C32.1893 1.99432 30.7595 2.00794 29.3296 2.01527L25.0385 2.02627L20.7474 2.01527C19.3175 2.00794 17.8871 1.99432 16.4562 1.97442Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M16.4562 2.51105C17.8871 2.49219 19.3175 2.4791 20.7474 2.47177L25.0385 2.4592L29.3296 2.47177C30.7595 2.47805 32.1893 2.49115 33.6192 2.51105C32.1893 2.532 30.7595 2.54562 29.3296 2.5519L25.0385 2.5629L20.7474 2.5519C19.3175 2.53933 17.8871 2.52572 16.4562 2.51105Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M9.65934 8.63916L5.19066 25.4281L2.64207 35.0003L0.183044 34.3451L2.73164 24.7729L7.20031 7.98395L9.65934 8.63916Z",
    fill: "#E30917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    opacity: 0.1,
    d: "M9.65934 8.63916L5.19066 25.4281L2.64207 35.0003L0.183044 34.3451L2.73164 24.7729L7.20031 7.98395L9.65934 8.63916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M4.93377 25.3577L9.40399 8.56917L7.45442 8.05006L2.98419 24.8386L4.93377 25.3577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M8.71374 9.55157C8.38064 10.8631 8.04229 12.1724 7.69871 13.4797L6.66167 17.4079L5.60893 21.3361C5.25487 22.6434 4.89662 23.9496 4.53418 25.2548C4.86938 23.9423 5.20825 22.6329 5.55079 21.3266L6.58625 17.3985L7.64057 13.4703C7.99463 12.163 8.35235 10.8568 8.71374 9.55157Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M8.3324 9.44805C7.99824 10.7616 7.65937 12.071 7.31579 13.3762L6.28033 17.3044L5.22601 21.2325C4.873 22.5398 4.51527 23.8461 4.15283 25.1513C4.48699 23.8398 4.82586 22.5304 5.16944 21.2231L6.2049 17.2949L7.25922 13.3668C7.61328 12.0595 7.97101 10.7532 8.3324 9.44805Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M7.95001 9.34664C7.61585 10.6592 7.27698 11.9686 6.9334 13.2748L5.89794 17.203L4.84362 21.1311C4.49061 22.4384 4.13289 23.7441 3.77045 25.0483C4.10355 23.7358 4.4419 22.4264 4.78548 21.1201L5.82252 17.192L6.87527 13.2638C7.22828 11.9617 7.58652 10.656 7.95001 9.34664Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M7.56653 9.24523C7.23342 10.5567 6.89507 11.8661 6.55149 13.1734L5.51445 17.1016L4.46171 21.0297C4.1087 22.337 3.75045 23.6427 3.38696 24.9469C3.72112 23.6354 4.05999 22.326 4.40357 21.0187L5.43903 17.0906L6.49335 13.1624C6.84741 11.8551 7.20514 10.5494 7.56653 9.24523Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M25.6282 31.6738L44.4127 31.6738V25.1342L25.6282 25.1342V31.6738Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M12.4346 31.6738H25.6285V25.1342H12.4346V31.6738Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M25.6282 30.9914L44.4127 30.9914V25.8094L25.6282 25.8094V30.9914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M43.1962 29.9291C41.7297 29.9553 40.2658 29.9737 38.8045 29.9841L34.4129 30.0014L30.0133 29.9841C28.5468 29.9747 27.0803 29.9564 25.6138 29.9291C27.0803 29.903 28.5468 29.8841 30.0133 29.8726L34.4129 29.8569L38.8045 29.8726C40.269 29.8841 41.7328 29.903 43.1962 29.9291Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M43.1962 28.9108C41.7297 28.937 40.2658 28.9553 38.8045 28.9658L34.4129 28.9831L30.0133 28.9658C28.5468 28.9564 27.0803 28.9381 25.6138 28.9108C27.0803 28.8846 28.5468 28.8658 30.0133 28.8543L34.4129 28.8385L38.8045 28.8543C40.269 28.8647 41.7328 28.8836 43.1962 28.9108Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M43.1962 27.8962C41.7297 27.9224 40.2658 27.9407 38.8045 27.9512L34.4129 27.9685L30.0133 27.9512C28.5468 27.9417 27.0803 27.9234 25.6138 27.8962C27.0803 27.8689 28.5468 27.8501 30.0133 27.8396L34.4129 27.8223L38.8045 27.8396C40.269 27.849 41.7328 27.8679 43.1962 27.8962Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M43.1962 26.88C41.7297 26.9072 40.2658 26.9255 38.8045 26.935L34.4129 26.9522L30.0133 26.935C28.5468 26.9255 27.0803 26.9072 25.6138 26.88C27.0803 26.8517 28.5468 26.8328 30.0133 26.8234L34.4129 26.8061L38.8045 26.8234C40.269 26.8328 41.7328 26.8517 43.1962 26.88Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M48.817 9.56003H14.3403V14.0161H48.817V9.56003Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M30.8411 10.4706H17.5812V13.1449H30.8411V10.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M46.49 10.4706H34.0425V10.8839H46.49V10.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M46.49 11.5819H34.0425V11.9951H46.49V11.5819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M46.49 12.6932H34.0425V13.1064H46.49V12.6932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M42.1476 3.41626H16.7245V9.53948H42.1476V3.41626Z",
    fill: "#E30917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M39.45 3.41626H37.0805V9.53948H39.45V3.41626Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M35.5268 3.41626H34.6076V9.53948H35.5268V3.41626Z",
    fill: "#7E7E7D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyresources);
export default __webpack_public_path__ + "static/media/myresources.de328942a12cc76e07d10490b39477d8.svg";
export { ForwardRef as ReactComponent };